var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Modal',{attrs:{"footer-hide":true,"mask-closable":false,"width":"360"},model:{value:(_vm.showcode),callback:function ($$v) {_vm.showcode=$$v},expression:"showcode"}},[_c('div',{staticClass:"box"},[_c('div',{attrs:{"id":"qrcode3"}}),_c('div',{staticClass:"box-txt"},[_c('span',[_vm._v("使用微信扫一扫 继续交流")])])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }